import {
  fetchTransferInventoryStart,
  fetchTransferInventorySuccess,
  fetchTransferInventoryFailure,
} from "./reducer";

import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

import { GET_ALL_TRANSFER_INVENTORY } from "../../constants/constants";

export const getAllTransferInventory =
  (first = 0, offset = 10, itemId = "", setLoading) =>
  async (dispatch) => {
    try {
      setLoading?.(true);

      dispatch(fetchTransferInventoryStart());

      const response = await determineBaseUrlAndPerformApiCall(
        GET_ALL_TRANSFER_INVENTORY(first, offset, itemId),
        "GET"
      );

      dispatch(fetchTransferInventorySuccess(response));

      setLoading?.(false);
    } catch (error) {
      setLoading?.(false);

      dispatch(fetchTransferInventoryFailure(error.message));
    }
  };